"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NoData_1 = __importDefault(require("@/react-app/features/Statistic/components/NoData"));
function EmptyStatistic(_a) {
    var angularJsDependencies = _a.angularJsDependencies;
    return (react_1.default.createElement("div", { className: "empty-statistics" },
        react_1.default.createElement(NoData_1.default, { angularJsDependencies: angularJsDependencies })));
}
exports.default = EmptyStatistic;
